/** The accent palette used for note tiles. Values live in CSS; this is the name registry. */
export const NOTE_COLORS = ["sand", "coral", "amber", "mint", "sky", "lilac"] as const;
export type NoteColor = (typeof NOTE_COLORS)[number];
